import styled from 'styled-components';
import {
  color, typography, layout, space,
} from 'styled-system';

const Text = styled.div(
  {
    display: 'inline-block',
  },
  color,
  typography,
  layout,
  space,
);
export default Text;
